export default {
  PUT: 'PUT',
  POST: 'POST',
  DELETE: 'DELETE'
}
